import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { ErrorLoggerService } from '../services/error-logger.service';
import { CORRELATION_HEADER } from '../utils/correlation-id';

export const httpErrorLoggerInterceptor: HttpInterceptorFn = (req, next) => {
  const errorLogger = inject(ErrorLoggerService);
  const correlationId = req.headers.get(CORRELATION_HEADER) ?? undefined;

  return next(req).pipe(
    catchError((error: unknown) => {
      const errorContext = {
        correlationId,
        method: req.method,
        requestUrl: req.urlWithParams,
      };

      if (error instanceof HttpErrorResponse) {
        errorLogger.logHttpError(error, errorContext);
      } else {
        errorLogger.logError(error, {
          ...errorContext,
          type: 'http_error',
        });
      }
      return throwError(() => error);
    }),
  );
};
